<template>
  <div class="data-box">
    <div id="advert">
      <div class="bg1">
        <div>
          <img src="./icons/icon-01.png" alt="" class="icon01">
          <img src="./icons/icon-02.png" alt="" class="icon02">
          <img src="./icons/icon-03.png" alt="" class="icon03">
          <img src="./icons/icon-04.png" alt="" class="icon04">
          <img src="./icons/icon-05.png" alt="" class="icon05">
          <img src="./icons/icon-06.png" alt="" class="icon06">
          <img src="./icons/icon-07.png" alt="" class="icon07">
        </div>
      </div>
      <div class="bg2">
        <div>
                <span class="icon08">
                    <img src="./icons/icon-08.png" alt="" width="10px">
                </span>
          <span class="icon09">
                    <img src="./icons/icon-09.png" alt="" width="30px">
                </span>
          <span class="icon10">
                    <img src="./icons/icon-10.png" alt="" width="20px">
                </span>
        </div>
      </div>
      <div class="bg3">
        <div>
                <span class="icon11">
                    <img src="./icons/icon-11.png" alt="" width="26px">
                </span>
          <span class="icon12">
                    <img src="./icons/icon-12.png" alt="" width="18px">
                </span>
        </div>
      </div>
    </div>
    <div class="module-right">
      <div class="module-right-top">
        <p class="des-item-box">
          <span class="icon-img"><img src="../../../assets/11.fw.png" height="24" width="22" style="margin-top: 3px"/></span>
          最优价
          <font class="right-font" style="color:#02F3F3">60</font>
        </p>
        <p class="des-item-box">
          <span class="icon-img"><img src="../../../assets/22.fw.png" height="22" width="19" style="margin-top: 3px"/></span>推荐价
          <font class="right-font" style="color:#FEE052">60</font>
        </p>
      </div>
      <div class="echarts-box" id="echarts-area">

      </div>
    </div>
  </div>
</template>

<script>
import {getPie3D} from "./chart";

export default {
  name: "left-module-two",
  mounted() {
 this.initNewEchars()
    this.initData()
    // this.initNewEchars()
  },
  methods:{
    initData(){
      let showApplyfor = document.querySelector("#advert .content span");
      if(showApplyfor){
      showApplyfor.addEventListener("click", function () {
        document.querySelectorAll("#advert .content")[0].style.background = "#FFFFFF";
        document.querySelector("#advert .content span").style.display = "none";
        document.querySelector("#advert .content img").style.display = "none";
        document.querySelectorAll("#advert .bg1")[0].className = "bg1 animation-five";
        document.querySelectorAll("#advert .bg2")[0].className = "bg2 animation-five";
        document.querySelectorAll("#advert .bg3")[0].className = "bg3 animation-five";
        document.querySelectorAll(".content")[0].className = "content animation-four";
        setTimeout(function () {
          document.querySelector("#advert").style.display = "none";
          document.querySelector("#applyfor").style.display = "block";
          document.querySelector("#applyfor i").className = "animation-one";
          document.querySelector("#applyfor form div").className = "animation-six";
          setTimeout(function () {
            document.querySelectorAll("#applyfor input")[0].className = "animation-one";
            setTimeout(function () {
              document.querySelectorAll("#applyfor input")[0].style.left = "16px";
            }, 600);
            setTimeout(function () {
              document.querySelectorAll("#applyfor input")[1].className = "animation-one";
              setTimeout(function () {
                document.querySelectorAll("#applyfor input")[1].style.left = "16px";
              }, 600);
              setTimeout(function () {
                document.querySelectorAll("#applyfor input")[2].className = "animation-one";
                setTimeout(function () {
                  document.querySelectorAll("#applyfor input")[2].style.left = "16px";
                }, 600);
                setTimeout(function () {
                  document.querySelector("#applyfor button").className = "animation-two";
                  setTimeout(function () {
                    document.querySelector("#applyfor button").style.left = "70px";
                  }, 600);
                  setTimeout(function () {
                    document.querySelector("#applyfor #shadow").className = "animation-three";
                    setTimeout(function () {
                      document.querySelector("#applyfor #shadow").style.top = "8px";
                      document.querySelector("#applyfor #shadow").style.left = "8px";
                    }, 600);
                  }, 200);
                }, 200);
              }, 200);
            }, 200);
          }, 200);
        }, 300);
      })
      }
    },
    initNewEchars(){
     let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {show: false},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '0%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          data: ['外盘1', '外盘2', '外盘3', '外盘4', '外盘5']
        },
        series: [
          {
            name: '2011',
            type: 'bar',
            data: [182, 234, 290, 104, 131, 230],
            itemStyle: {
              color: '#D87529'
            }
          },
        ]
      };
      let myCharts = this.$echarts.init(document.getElementById('echarts-area'))
      myCharts.setOption(option)}
  }
}
</script>

<style scoped>
.data-box {
  display: flex;
}
.module-right {
  display: flex;
  flex-direction: column;
  width: calc(100% - 240px);
}
.module-right-top {
  margin: 20px 0 0 30px;
}

.echarts-box {
  width: 95%;
  height: calc(95% - 100px);
}
.des-item-box {
  display: flex;
  color: #fff;
  border: 1px solid;
  border-image: linear-gradient(to right, #8f41e9, #002D86) 1;
  border-radius: 10px;
  margin-top: 10px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  align-items: center;
  width: 150px;
  font-size: 12px;
}
.right-font {
  display: inline-block;
  font-weight: bold;
  flex: 1;
  text-align: right;
  margin-right: 10px;
  font-size: 16px;
}
.icon-img {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0 5px;
}
@keyframes animtran {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}

@keyframes animtrans {
  from {
    transform: rotateZ(360deg);
  }
  to {
    transform: rotateZ(0deg);
  }
}

@-webkit-keyframes animtran {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}

@-webkit-keyframes animtrans {
  from {
    transform: rotateZ(360deg);
  }
  to {
    transform: rotateZ(0deg);
  }
}

#advert {
  width: 230px;
  height: 230px;
  position: relative;
  display: inline-block;
  margin: 20px;
}

#advert .bg1 {
  width: 220px;
  height: 220px;
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
}

#advert .bg1 div {
  width: 220px;
  height: 220px;
  border: #ccc 1px solid;
  border-radius: 15em;
  position: relative;
  animation: animtran 16s linear infinite;
  -webkit-animation: animtran 16s linear infinite;
}

#advert .bg1 img {
  width: 40px;
  position: absolute;
  animation: animtrans 16s linear infinite;
  -webkit-animation: animtrans 16s linear infinite;
}

#advert .bg1 .icon01 {
  bottom: 25px;
  left: 7px;
}

#advert .bg1 .icon02 {
  top: 80px;
  left: -24px;
}

#advert .bg1 .icon03 {
  top: -7px;
  left: 44px;
}

#advert .bg1 .icon04 {
  top: -7px;
  right: 44px;
}

#advert .bg1 .icon05 {
  top: 80px;
  right: -24px;
}

#advert .bg1 .icon06 {
  bottom: 25px;
  right: 7px;
}

#advert .bg1 .icon07 {
  bottom: -25px;
  left: 105px;
}

#advert .bg2 {
  width: 130px;
  height: 130px;
  position: absolute;
  top: 65px;
  left: 65px;
  z-index: 9;
}

#advert .bg2 div {
  width: 130px;
  height: 130px;
  border: #e376bd 1px solid;
  border-radius: 15em;
  position: relative;
  animation: animtrans 12s linear infinite;
  -webkit-animation: animtrans 12s linear infinite;
}

#advert .bg2 span {
  display: inline-block;
  background-color: #FFFFFF;
  overflow: hidden;
  border-radius: 15em;
  position: absolute;
  animation: animtran 6s linear infinite;
  -webkit-animation: animtran 6s linear infinite;
}

#advert .bg2 img {
  padding: 4px;
  display: block;
}

#advert .bg2 .icon08 {
  top: 10px;
  left: 13px;
}

#advert .bg2 .icon09 {
  bottom: 0;
  left: 7px;
}

#advert .bg2 .icon10 {
  bottom: 40px;
  right: -15px;
}


#advert .bg3 {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 100px;
  left: 100px;
  z-index: 8;
}

#advert .bg3 div {
  width: 60px;
  height: 60px;
  border: #e077bf 1px dotted;
  border-radius: 15em;
  position: relative;
  animation: animtran 8s linear infinite;
  -webkit-animation: animtran 8s linear infinite;
}

#advert .bg3 span {
  display: inline-block;
  background-color: #FFFFFF;
  overflow: hidden;
  border-radius: 15em;
  position: absolute;
  animation: animtrans 4s linear infinite;
  -webkit-animation: animtrans 4s linear infinite;
}

#advert .bg3 img {
  padding: 5px;
  display: block;
}

#advert .bg3 .icon11 {
  top: -14px;
  right: 0px;
}

#advert .bg3 .icon12 {
  bottom: -13px;
  right: 10px;
}

#advert .content {
  width: 130px;
  height: 50px;
  background: linear-gradient(to right, #fa71ad, #c77dd1);
  position: absolute;
  z-index: 11;
  left: 85px;
  top: 125px;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  box-shadow: #f6f6f6 8px 8px 8px 4px;
  cursor: pointer;
}


@keyframes ani-one {
  from {
    left: 220px;
  }
  to {
    left: 16px
  }
}

@keyframes ani-two {
  from {
    left: 220px;
  }
  to {
    left: 70px
  }
}

@keyframes ani-three {
  from {
    top: 0;
    left: 0;
  }
  to {
    top: 8px;
    left: 8px;
  }
}

@keyframes ani-four {
  0% {
    width: 130px;
    height: 50px;
    left: 85px;
    top: 125px;
    box-shadow: #f6f6f6 8px 8px 8px 4px;
    border: #eee 0px solid;
    margin-left: 0;
  }
  100% {
    width: 259px;
    height: 333px;
    left: 50%;
    top: 0px;
    box-shadow: #FFFFFF 0 0 0 0;
    border: #eee 1px solid;
    margin-left: -130px;
  }
}

@keyframes ani-five {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes ani-six {
  from {
    left: 220px;
  }
  to {
    left: 0;
  }
}

@-webkit-keyframes ani-one {
  from {
    left: 220px;
  }
  to {
    left: 16px
  }
}

@-webkit-keyframes ani-two {
  from {
    left: 220px;
  }
  to {
    left: 70px
  }
}

@-webkit-keyframes ani-three {
  from {
    top: 0;
    left: 0;
  }
  to {
    top: 8px;
    left: 8px;
  }
}

@-webkit-keyframes ani-four {
  0% {
    width: 130px;
    height: 50px;
    left: 85px;
    top: 125px;
    box-shadow: #f6f6f6 8px 8px 8px 4px;
    border: #eee 0px solid;
    margin-left: 0;
  }
  100% {
    width: 259px;
    height: 333px;
    left: 50%;
    top: 0px;
    box-shadow: #FFFFFF 0 0 0 0;
    border: #eee 1px solid;
    margin-left: -130px;
  }
}

@-webkit-keyframes ani-five {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@-webkit-keyframes ani-six {
  from {
    left: 220px;
  }
  to {
    left: 0;
  }
}
.animation-paused {
  animation-play-state: paused !important;
  -webkit-animation-play-state: paused !important;
}

.animation-one {
  animation: ani-one 0.6s ease 1;
  -webkit-animation: ani-one 0.6s ease 1;
}

.animation-two {
  animation: ani-two 0.6s ease 1;
  -webkit-animation: ani-two 0.6s ease 1;
}

.animation-three {
  animation: ani-three 0.6s ease 1;
  -webkit-animation: ani-three 0.6s ease 1;
}

.animation-four {
  animation: ani-four 0.3s ease 1;
  -webkit-animation: ani-four 0.3s ease 1;
}

.animation-five {
  animation: ani-five 0.5s ease 1;
  -webkit-animation: ani-five 0.5s ease 1;
}

.animation-six {
  animation: ani-six 0.6s ease 1;
  -webkit-animation: ani-six 0.6s ease 1;
}

.opacity0 {
  opacity: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/left-module-two.vue